import React from "react";
import { fetchAbandonedCarts,fetchLoyalCustomers } from "../../../actions/customers";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Loader } from "../../../components/loader";
import { NotificationManager } from "react-notifications";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import filterFactory, {
  textFilter,
  selectFilter
} from "react-bootstrap-table2-filter";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import classnames from "classnames";
import { BreadCrumb } from "../../../components/breadcrumb";
import MessageToAbandonCustomers from "../../../components/dataModal/messagetoAbandonCustomers";

const $ = window.$;
const { SearchBar } = Search;
const toCapitalize = (name) => {
  if (name && name.length > 1) {
    return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
  }
};
class CenteredTabs extends React.Component {
  constructor(props) {
    super(props);
  }
  state = {
    loyalCustomersData : [],
    loading : true,
  };

  
  tableHeaderTopColumnData= [
    {
      dataField: "customerNames",
      text: "Customer Name(s)",
      sort: true,   
    },
    {
      dataField: "contractCount",
      text: "Count",
      sort: true,   
    },
  ];

  tableHeaderAbandonedColumnData = [

    {
      dataField: 'id', text: 'Pet ID / Medical Record',
      sort: true,
      formatter: (cell,row) => {
        return(
          <span className="m-topbar__userpic">
          {row && row.MedicalRecord.avatar_path ? (
            <img
              src={
                process.env.REACT_APP_S3_PATH +
                "/" +
                row.MedicalRecord.
                 avatar_path +
                "/" +
                row.MedicalRecord.     
                avatar_file_name
              }
              className="m--img-rounded m-width-50 mr-2"
              alt=""
            />
          ):null 
            }
          {row.MedicalRecord.pet_id ? (      
            <strong>
            <a
              href={ `${process.env.REACT_APP_API_ENDPOINT}/core/medicalrecord/pdf/${this.props.data.petShopReducer.currentPetshop.id }/${row.MedicalRecord.id}`}
              target="_blank"  
              style={{ color:"#ffff"}}      
             >
            <span className="m-badge m-badge--info mx-auto my-0 px-2">{row.MedicalRecord.pet_id}</span>
            </a>
          </strong>
          ) : ( 
            <span className="m--font-boldest">(Does Not Exist)</span>   

          )}
        </span>
        )
      }
    },
    {
      dataField: 'medicalRecordId', text: 'First Name', sort: true,
      formatter: (cell,row) => {
        return(
          <span className="m-topbar__userpic">       

          {row.Customer && row.Customer.firstname ? (   
        
            <span >{row.Customer.firstname}</span>    
      
          ) : ( 
            <span className="m--font-boldest">(Does Not Exist)</span>   

          )}
         </span>
             
      )}
    },
    {
      dataField: 'medicalRecordId', text: 'Last Name', sort: true,
      formatter: (cell,row) => {
        return(
          <span className="m-topbar__userpic">       

          {row.Customer && row.Customer.lastname ? (   
        
            <span >{row.Customer.lastname}</span>    
      
          ) : ( 
            <span className="m--font-boldest">(Does Not Exist)</span>   

          )}
         </span>
             
      )}
    },
    {
      dataField: 'medicalRecordId', text: 'Email', sort: true,
      formatter: (cell,row) => {
        return(
          <span className="m-topbar__userpic">       

          {row.Customer && row.Customer.email ? (   
        
            <span >{row.Customer.email}</span>    
      
          ) : ( 
            <span className="m--font-boldest">(Does Not Exist)</span>   

          )}
         </span>
             
      )}
    },
    {
      dataField: 'medicalRecordId', text: 'Phone', sort: true,
      formatter: (cell,row) => {
        return(
          <span className="m-topbar__userpic">       

          {row.Customer && row.Customer.phone_primary ? (   
        
            <span >{row.Customer.phone_primary}</span>    
      
          ) : ( 
            <span className="m--font-boldest">(Does Not Exist)</span>   

          )}
         </span>
             
      )}
    },
  
  ];

  expandRow = {
    renderer: (row, rowIndex) => (  
      <div>            
        <ToolkitProvider
          keyField="id"
          data={ row.contracts }
          columns={this.tableHeaderAbandonedColumnData}
          search
          hover={true}
          filter={filterFactory()}                       
        >
        {props => (
          <div>                                              
            <BootstrapTable  
             classes="breedersPuppyChildTable"                          
             {...props.baseProps}                       
            />  
           </div>                    
        )}
       </ToolkitProvider>  
      </div>
   ),
     showExpandColumn: true ,
     expandHeaderColumnRenderer: ({ isAnyExpands }) => {
             if (isAnyExpands) {
             return <b style={{cursor: 'pointer'}}><i className="fas fa-chevron-circle-up"></i></b>;
             }
             return <b style={{cursor: 'pointer'}}><i className="fas fa-chevron-circle-down"></i></b>;
           },
     expandColumnRenderer: ({ expanded }) => {
             if (expanded) {
               return (
                 <div style={{cursor: 'pointer', marginTop: '0px'}}><i className="fas fa-chevron-circle-up"></i></div>
               );
             }
             return (
               <div style={{cursor: 'pointer', marginTop: '0px'}}><i className="fas fa-chevron-circle-down"></i></div>
             );
           }
  };


  componentDidMount() {    
    this.props.fetchLoyalCustomers();
  
  }

  componentWillReceiveProps = nextProps => {   

    if(nextProps.loyalCustomersData !== this.props.loyalCustomersData){     
        this.setState({ loyalCustomersData : nextProps.loyalCustomersData, loading : false});
    }

    if (nextProps.abandonedCartsError !== this.props.abandonedCartsError) {
      NotificationManager.error('Failed to load abandoned cart.');
      this.setState({ loading : false });
    }
 

  }; 


  render() {
   
    const {   
      loyalCustomersData
    } = this.state;

    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">    
          <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
            <div className="m-grid__item m-grid__item--fluid m-wrapper">
              <div className="m-portlet m-portlet--mobile">
                <div className="m-portlet__head medical-record-head-btn-set" >
                  <div className="m-portlet__head-caption">
                    <div className="m-portlet__head-title">
                      <h3 className="m-portlet__head-text">
                        Loyal Customers                  
                      </h3>
                    </div>
                  </div>         
                </div>
                <div className="m-portlet__body medical-record-content">  

                {this.state.loading ?
                  <div className="center-row">
                      <Loader size={50}/>
                  </div>
                   :<ToolkitProvider
                      keyField="id"
                      data={ loyalCustomersData }
                      columns={this.tableHeaderTopColumnData}
                      search
                      hover={true}
                      filter={filterFactory()}
                    >
                      {props => (
                        <div>
                          <div className="px-0 mb-4 search-bar">
                            <div className="col-lg-3 px-0 inner-addon right-addon">
                              <i className="fas fa-search"></i>
                              <SearchBar {...props.searchProps} />
                            </div>
                          </div>                 
                            <BootstrapTable
                              classes="petTable"
                              {...props.baseProps}
                              pagination={paginationFactory()}
                              expandRow={ this.expandRow } 
                            />                        
                        </div>
                      )}
                    </ToolkitProvider>  
                    }            
                </div>
              </div> 
            </div>

            <MessageToAbandonCustomers openClose={this.state.messageSubscribers} />
          </div>
        </div>  

      </div>
    );
  }
}

const mapStateToProps = state => ({
  data: state,
  loyalCustomersData : state.customersReducer.loyalCustomersData,
  loyalCustomersDataError : state.customersReducer.loyalCustomersData,

  
});

const mapDispatchToProps = dispatch => ({
  fetchAbandonedCarts: () => {
    dispatch(fetchAbandonedCarts());
  },
  fetchLoyalCustomers: () => {
    dispatch(fetchLoyalCustomers());
  },
});

CenteredTabs = connect(mapStateToProps, mapDispatchToProps)(CenteredTabs);

export default withRouter(CenteredTabs);

